import { downloadCSV } from '@helpers/downloadCSV';
import { formatPrice } from '@helpers/formatPrice';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { PrismaBillingAccountDto } from 'app/API';

const headers = ['ID', 'Name', 'Organization', 'Balance', 'Rate', 'Created'];

type TBillingAccountCsvData = Pick<PrismaBillingAccountDto, 'id' | 'name' | 'fixedRate' | 'tierRate' | 'createdAt'>;

export const downloadBillingAccountsCsv = (billingAccounts: TBillingAccountCsvData[]) => {
  const array = billingAccounts.map((data) => {
    let rate = data.fixedRate ? 'Fixed: ' : '';
    rate += `${formatPrice(data.tierRate ?? 0)}/hr`;
    return {
      id: data.id,
      name: data.name,
      organization: '',
      balance: '0',
      rate,
      created: getAmericanTime(data.createdAt),
    };
  });
  return downloadCSV(array, headers);
};
